import { useEffect } from "react";
import { toast } from "sonner";
import { useLocation } from "react-router-dom";

interface UsePreventBackOptions {
  /** Whether back button prevention is active. Default: true */
  enabled?: boolean;
  /** Whether to show a toast message when back navigation is attempted. Default: true */
  showMessage?: boolean;
  /** Custom toast message text */
  message?: string;
}

/**
 * Hook customizado para bloquear la navegación hacia atrás del navegador (Browser Back Button)
 * en el Dashboard, manteniendo al usuario dentro de la aplicación.
 */
export function usePreventBack({
  enabled = true,
  showMessage = true,
  message = "La navegación hacia atrás está deshabilitada en el Dashboard.",
}: UsePreventBackOptions = {}) {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;

    // Asegurar que el estado inicial en el historial esté atrapado
    window.history.pushState(null, "", window.location.href);

    const handlePopState = (event: PopStateEvent) => {
      // Volver a empujar el estado para prevenir la salida o retroceso
      window.history.pushState(null, "", window.location.href);

      if (showMessage) {
        toast.info(message, {
          id: "prevent-back-dashboard-toast",
          duration: 3000,
        });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [enabled, showMessage, message, location.pathname]);
}
